import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _asyncToGenerator from '../../../node_modules/@babel/runtime/helpers/asyncToGenerator.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import regenerator from '../../../node_modules/@babel/runtime/regenerator/index.js';
import { Label, FormHelp } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { useEffect, useCallback } from 'react';
import LabeledAddressInputAutocompleteField from '../../common/LabeledAddressInputAutocompleteField.js';
import { queryAutocomplete, getRegionInformation } from '../api.js';
import { INPUTS } from '../constants.js';
import jsxRuntime from '../../../node_modules/react/jsx-runtime.js';

var _excluded = ["register", "setValue", "errors", "trigger", "clearErrors"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MODES = LabeledAddressInputAutocompleteField.MODES;
var VALIDATION_KEYS = [INPUTS.cityOrZip, INPUTS.zipCode, INPUTS.city];
var DEFAULT_REGISTER_PROPS = {
  required: 'City or zip code is required'
};
var mode = [MODES.CITY, MODES.ZIP];
var LocationField = function LocationField(_ref) {
  var register = _ref.register,
    setValue = _ref.setValue,
    errors = _ref.errors,
    trigger = _ref.trigger,
    clearErrors = _ref.clearErrors,
    rest = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    register(INPUTS.cityOrZip, DEFAULT_REGISTER_PROPS);
    register(INPUTS.city, DEFAULT_REGISTER_PROPS);
    register(INPUTS.zipCode, DEFAULT_REGISTER_PROPS);
    register(INPUTS.state);
  }, [register]);
  var triggerValidation = useCallback(function () {
    return trigger(VALIDATION_KEYS);
  }, [trigger]);
  var handleOnChange = useCallback(function (value) {
    clearErrors(VALIDATION_KEYS);
    setValue(INPUTS.cityOrZip, value);

    // reset other values
    setValue(INPUTS.zipCode, '');
    setValue(INPUTS.city, '');
    setValue(INPUTS.state, '');
  }, [setValue, clearErrors]);
  var handleOnSelection = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(_ref2) {
      var display, city, zipCode, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              display = _ref2.display, city = _ref2.city, zipCode = _ref2.zipCode, state = _ref2.state;
              _context.next = 3;
              return setValue(INPUTS.cityOrZip, display);
            case 3:
              _context.next = 5;
              return setValue(INPUTS.zipCode, zipCode);
            case 5:
              _context.next = 7;
              return setValue(INPUTS.city, city);
            case 7:
              _context.next = 9;
              return setValue(INPUTS.state, state);
            case 9:
              triggerValidation();
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [setValue, triggerValidation]);
  var error = errors.cityOrZip || errors.zipCode || errors.city;
  return /*#__PURE__*/jsxRuntime.jsx(LabeledAddressInputAutocompleteField, _objectSpread({
    mode: mode,
    "aria-label": "Location",
    renderLabel: function renderLabel(labelProps) {
      return /*#__PURE__*/jsxRuntime.jsx(Label, _objectSpread(_objectSpread({}, labelProps), {}, {
        children: "Location"
      }));
    },
    description: /*#__PURE__*/jsxRuntime.jsx(FormHelp, {
      children: "Enter the city or zip code for the area you\u2019re looking to buy in."
    }),
    error: error,
    queryAutocomplete: queryAutocomplete,
    getRegionInformation: getRegionInformation,
    onChange: handleOnChange,
    onBlur: triggerValidation,
    onSelection: handleOnSelection
  }, rest));
};
LocationField.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  trigger: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  errors: PropTypes.object
};
LocationField.defaultProps = {
  errors: {}
};
var LocationField$1 = LocationField;

export { LocationField$1 as default };
//# sourceMappingURL=LocationField.js.map
